import { useNavigate } from "react-router-dom";
import { useAtomValue } from "jotai";

import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";
import { tenantIDAtom, cloudLogo } from "../../atoms/GlobalAtoms";

interface Props {
  toggleOpen: () => void;
  open: boolean;
}

const baseSidebarLinkCss =
  "tw:text-[13px] tw:transition tw:delay-50 tw:duration-300 tw:ease-in-out tw:border-transparent  tw:hover:bg-sidebar-link tw:font-medium tw:text-dark tw:cursor-pointer tw:rounded-md tw:block tw:px-3 tw:py-2 tw:no-underline";

const SidebarToggler = ({ toggleOpen, open }: Props) => {
  const navigate = useNavigate();
  const tenantID = useAtomValue(tenantIDAtom);
  const tenantLogo = useAtomValue(cloudLogo);

  return (
    <div className="tw:flex tw:mt-3 tw:mb-4 tw:justify-between">
      {open && (
        <img
          alt=""
          src={tenantLogo ? tenantLogo : GCLogo}
          style={{ maxWidth: 170, objectFit: "contain", height: 30 }}
          className="tw:block tw:cursor-pointer"
          onClick={
            tenantID
              ? () => navigate(`/clouds/${tenantID}/activity`)
              : undefined
          }
        />
      )}
      <div
        className={`${baseSidebarLinkCss} tw:flex tw:items-center tw:justify-center tw:hover:border tw:hover:border-superlight ${
          !open
            ? "tw:text-center tw:h-[37px] tw:w-[37px]"
            : "tw:h-[30px] tw:w-[30px] tw:text-[22px]"
        }`}
        onClick={toggleOpen}
      >
        {open ? (
          <i className="mdi mdi-menu-open tw:cursor-pointer" />
        ) : (
          <i
            className="mdi mdi-menu tw:cursor-pointer"
            style={{ fontSize: 18 }}
          />
        )}
      </div>
    </div>
  );
};

export default SidebarToggler;
